import React, { ReactElement, useMemo, useState } from "react";

// context
import { CartOverlaysContext } from "./CartOverlaysContext";

// hooks
import { useRegisterCrouton } from "@checkout-core/hooks/useRegisterCrouton";

// types
import { useRegisterModalAndHalfcard } from "@checkout-core/hooks/useRegisterModalAndHalfcard";

// Using union type for enabledOverlayId
export function CartOverlayActionProvider(props: { children: React.ReactNode }): ReactElement {
    const [overLaysState, setOverLaysState] = useState<{ enabledOverlayId: string }>({
        enabledOverlayId: "",
    });

    const [overLaysCroutonState, setOverLaysCroutonState] = useState<{
        enabledCroutonId: string;
    }>({
        enabledCroutonId: "",
    });
    const croutonProps = useRegisterCrouton(setOverLaysCroutonState);
    const overlayProps = useRegisterModalAndHalfcard(setOverLaysState);

    const contextValue = useMemo(
        () => ({
            ...overlayProps,
            ...croutonProps,
        }),
        // TODO: we are recomputing contextValue when overLaysState and overLaysCroutonState changes to get updated values
        [croutonProps, overLaysState.enabledOverlayId, overLaysCroutonState.enabledCroutonId, overlayProps],
    );

    return <CartOverlaysContext.Provider value={contextValue}>{props.children}</CartOverlaysContext.Provider>;
}
